module.exports = __webpack_public_path__ + "img/trends-list.736994ee.png";